import React from 'react';

import { DEFAULT_ICON_PROPS, IIconProps } from '../constants';

export const SunkenTreeIcon = ({
  ariaLabel = 'Map waypoint icon for a sunken tree',
  ...props
}: IIconProps) => {
  const { size, width, height, title, ariaHidden, className } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={size || width}
      height={size || height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ariaLabel}
      aria-hidden={ariaHidden}
      className={`block ${className}`}
      {...props}
    >
      {title && <title>{title}</title>}

      <rect x="0.726562" width="32" height="32" rx="16" fill="#E9F8FF" />
      <path
        d="M16.7266 6.78125C20.5963 6.78125 23.7578 10.0269 23.7578 14.0608C23.7578 17.106 21.9774 19.9028 20.1268 21.9771C19.2083 23.0066 18.2885 23.8403 17.5981 24.4166C17.2532 24.7045 16.9664 24.9273 16.7669 25.0776C16.7545 25.0869 16.7424 25.096 16.7307 25.1047C16.718 25.0949 16.7049 25.0848 16.6913 25.0743C16.4914 24.9195 16.2043 24.6903 15.8591 24.3955C15.168 23.8052 14.2473 22.9547 13.3279 21.9136C11.4738 19.8138 9.69531 17.0175 9.69531 14.0608C9.69531 10.0269 12.8568 6.78125 16.7266 6.78125Z"
        fill="#836651"
        stroke="white"
        strokeWidth="0.9375"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.2612 12.2011H20.2336C20.7522 12.2011 21.3707 12.5753 21.3706 14.3582C21.3706 16.1411 20.7523 16.5154 20.2336 16.5154H13.3779C13.1261 16.5154 12.0713 16.1411 12.0713 14.3582C12.0713 12.5753 12.9859 12.201 13.3779 12.201H15.7101C16.6959 12.0923 17.6579 10.9249 17.7136 10.8564C17.7429 10.8159 17.8714 10.6588 18.1055 10.6588C18.2206 10.6588 18.3404 10.6981 18.4618 10.7755C18.5721 10.8457 18.6405 10.9473 18.6541 11.0618C18.6701 11.1961 18.6131 11.3339 18.4847 11.4713L18.4249 11.5342L18.4235 11.5356C18.3076 11.6571 18.0395 11.9378 18.0116 12.0774C18.0061 12.1045 18.0122 12.1126 18.0164 12.1179C18.0524 12.1655 18.1771 12.1955 18.2612 12.2011ZM12.5316 14.3583C12.5316 15.3922 13.0621 15.9164 13.4474 15.9164C13.8327 15.9164 14.2887 15.3922 14.2886 14.3581C14.2886 14.1085 14.1561 13.6992 14.1561 13.6992L13.3192 14.5069L13.9561 13.0922C13.8327 12.8981 13.6118 12.7999 13.4474 12.7999C13.0621 12.7999 12.5316 13.3243 12.5316 14.3583Z"
        fill="white"
      />
    </svg>
  );
};
